














import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'AMXButton',
  props: {
    outline: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    blank: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const classes = [
      props.outline ? 'outline' : null,
      props.inline ? 'inline' : null,
      props.blank ? 'blank' : null,
      props.compact ? 'compact' : null,
    ]
      .filter(Boolean)
      .join(' ');

    const component = props.href ? 'nuxt-link' : 'button';

    return {
      component,
      classes,
    };
  },
});
